import React, { useState } from "react";
import PersonalInfo from "./Personal Info";
import Password from "./Password";
import AddressDetails from "./AddressDetails";
import "./style.scss";
import editIcon from "../../assets/icons/edit-icon-white.svg";
import profileIcon from "../../assets/icons/user_profile_pic.svg";
const ProfileContent = () => {
  const [profileDetails, setProfileDetails] = useState([]);
  return (
    <div className="profile_content_container">
      <div className="accountinfo_header">
        <div className="user_profile">
          <div className="user_name_info_wrapper">
            <img src={profileIcon} alt="" />
            <div className="user_name_info">
              <h2>{profileDetails.first_name +" "+ profileDetails.last_name}</h2>
              <p>{profileDetails.trader_badge}</p>
            </div>
          </div>
          {/* <button className="edit_button">
            Edit <img src={editIcon} alt="" />
          </button> */}
        </div>
        <button className="profile_edit_button"></button>
      </div>
      <PersonalInfo setProfileDetail={setProfileDetails} />
      <Password />
      <AddressDetails />
    </div>
  );
};

export default ProfileContent;
